import React, { useState, useCallback, useEffect } from "react";
import { InputGroup, Modal, Form, Row, Col, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import { endpoint, getSection } from "../../utils/api";
import SectionTags from "./SectionTags";

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faExclamation, faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faInfoCircle, faExclamation)

const SectionModal = ({ openNewModal, setOpenNewModal, setSectionError, setSectionCreated, setSectionUpdated, getSections, setSections, sections, sectionID, chosenDepartment, categories, chosenCategory, tags }) => {
  const [validated, setValidated] = useState(false);
  const [selectedTags, setSelectedTags] = useState([])
  const [section, setSection] = useState([]);
  const [tagsAlert, setTagsAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  let defaultTags = [];
  Object.keys(sections).map((section) => { 
        if(sections[section]._id === sectionID){
          defaultTags.push(sections[section].tags)      
        }
  });

  useEffect (() => {
      if (sectionID !== ''){
        getSection(setSection, sectionID, chosenDepartment);        
      }    
  }, [])

  useEffect (() => {
      setSelectedTags(section.tags);   
  }, [section])

  useEffect(() => {
    if (selectedTags !== undefined && selectedTags.length > 0 ){
      setTagsAlert(false)
    } 
  }, [selectedTags])

  let doc = "";
  const getWord = async () => {
    return Word.run(async (context) => {
      const paragraph = context.document.getSelection().getOoxml();

      await context.sync();
      doc = paragraph.value;
    });
  };


  const handleSubmit = async (e, props) => {
    setLoading(true);
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
      setLoading(false)
    } else if ((selectedTags === undefined || selectedTags.length === 0)) {
      setTagsAlert(true);
      e.preventDefault();
      e.stopPropagation();
      setLoading(false);
    } else {
      e.preventDefault();

      const name = document.getElementById("name");
      const description = document.getElementById("description");
      const category = document.getElementById("category")
      const changes = document.getElementById("changes")

      await getWord();
      
      let method
      if (sectionID === ''){
        method = "post";
      } else {
        method = "put";
      }

       await axios({
                method: method,
                url: `${endpoint}/sections`, 
                data: {
                    name: name.value,
                    file: doc,
                    description: description.value,
                    section_id: sectionID,
                    tags: selectedTags,
                    department: department.value,
                    category: category.value,
                    changes: changes?.value === undefined ? null : changes?.value
                } ,
                headers: {
                    Authorization: 'Bearer '+ localStorage.token,
                    DepartmentName: department.value
                }
            })
        .then(function (response) {
          setLoading(false);
          if (response.status === 200) {
            console.log("Message Sent.");
            if (sectionID === ""){
              setSectionCreated(true);
            } else {
              setSectionUpdated(true)
            }            
            setOpenNewModal(false);
            getSections(setSections, chosenDepartment, chosenCategory);
          } else {
            console.log(response.statusText);
            console.log(response.errors);
            setSectionError(false);
            setOpenNewModal(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setSectionError(error.response.data);
          setOpenNewModal(false);
        });
    }
  };


  return (
    <Modal backdropClassName="backdrop" show={openNewModal} onHide={() => setOpenNewModal(false)}>
      <Modal.Header className={sectionID === "" ?"modal-header" : "modal-header-edit" }>
        <Modal.Title >
          {sectionID === "" ? "New Section" : "Edit Section"}
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit} noValidate validated={validated} defaultValue={sectionID !== '' ? sectionID : ''}>
        <Modal.Body>
          <Form.Label>Name</Form.Label>
          <InputGroup className="mb-2">
            <Form.Control type="text" placeholder="Section Name..." id="name" name="name" defaultValue={sectionID !== '' ? section.name : ''} required />
            <Form.Control.Feedback type="invalid">Please choose a name.</Form.Control.Feedback>
          </InputGroup>

          <Form.Label>Description</Form.Label>
          <InputGroup className="mb-2">
            <Form.Control
              type="text"
              placeholder="Section description..."
              id="description"
              name="description"
              defaultValue={sectionID !== '' ? section.description : ''}
              required
            />
            <Form.Control.Feedback type="invalid">Please choose a description.</Form.Control.Feedback>
          </InputGroup>

          <Form.Label>Tags</Form.Label>
          <SectionTags setSelectedTags={setSelectedTags} whitelist={tags} defaultvalues={sectionID === "" ? "" : defaultTags}/>
          {tagsAlert && 

          <h5 className="no-category">            
          <FontAwesomeIcon 
            icon={faExclamation}  
            size='1x' 
            className='all-font-icons no-tags' 
            />
                You must select Tags!
            </h5>  
          }
          <Form.Label>Category</Form.Label>
            <InputGroup className="mb-2">
                    <Form.Control as="select" name="category" id="category">
                        {categories.map((c) => {
                            if(section.category !== undefined){ 
                                return <option selected={section.category.title === c.title} value={c.name} >{c.title} </option>
                            } else if (chosenCategory !== "All"){
                              return <option selected={chosenCategory === c.title} value={c.name} >{c.title} </option>
                            } else {
                                return <option value={c.title}>{c.title}</option>
                            }
                        })}                             
                    </Form.Control>
          </InputGroup>
          {sectionID !== "" &&
          <>
            <Form.Label>Revision Changes</Form.Label>
            <InputGroup className="mb-2">
                    <Form.Control as="textarea" name="changes" id="changes" required />
            </InputGroup> 
          </>
          }
        
          <Form.Label>Department</Form.Label>
          <InputGroup className="mb-2">
            <Form.Control type="text" placeholder="Department Name..." id="department" name="department" defaultValue={chosenDepartment} disabled />
          </InputGroup>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setOpenNewModal(false)}>
            Close
          </Button>
          <Button className="primary-button border-button" type="submit"  style={ {width: loading && '55px'}} disabled={loading}>
            {loading ? 
              <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="light"     
              />
            :
            "Save"
            }
          </Button>
          
             
        </Modal.Footer>
        
      </Form>

    </Modal>
    
  );
};

export default SectionModal;
